"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TableHeader = _interopRequireDefault(require("./TableHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var isITableHeader = function isITableHeader(value) {
  return _typeof(value) === "object" && "title" in value;
};

/**
 * Builds up the header for the table component, based on the _headers_ prop
 */
var DeprecatedTableHeader = function DeprecatedTableHeader(_ref) {
  var classes = _ref.classes,
    headers = _ref.headers,
    stickyHeader = _ref.stickyHeader;
  return /*#__PURE__*/_react.default.createElement("tr", null, headers === null || headers === void 0 ? void 0 : headers.map(function (header, index) {
    if (isITableHeader(header)) {
      return /*#__PURE__*/_react.default.createElement(_TableHeader.default, {
        key: index,
        sortBy: header.sortBy,
        minWidth: header.minWidth,
        width: header.width
      }, header.title);
    }
    return /*#__PURE__*/_react.default.createElement(_TableHeader.default, {
      key: index,
      className: stickyHeader && classes.stickyHeader
    }, header);
  }));
};
DeprecatedTableHeader.displayName = "DeprecatedTableHeader";
var _default = exports.default = DeprecatedTableHeader;